import { track as trackOriginal, TrackingConfig, TrackOptions } from '@gd/tracking'

let trackingConfig: TrackingConfig

export function useTracking(initialConfig?: TrackingConfig) {
  /**
   * Composable can be imported for tracking purposes
   * e.g. to set tracking endpoint to /tracking or /schellfisch
   * (see @gd/tracking)
   */

  if (!trackingConfig) {
    trackingConfig = initialConfig
  } else {
    console.warn('Initial tracking configuration has been set already.')
  }

  const track = (data: TrackOptions, config?: TrackingConfig) => {
    trackOriginal(data, { ...config, ...(trackingConfig && { ...trackingConfig }) })
  }

  return { track }
}
